<script lang="ts">
  import CmsImage from '$components/cms-image.svelte';
  import Icon from '$components/ui/icon/icon.svelte';
  import type { ReviewsStoryblok } from '$types/bloks';
  export let block: ReviewsStoryblok;
</script>

{#if block.body}
  <div class="container mx-auto px-4">
    <div class="reviews-item reviews-grid flex flex-col gap-4 flex-wrap max-h-[--main-max-height]">
      {#each block.body as review}
        {#if review.component === 'review-text'}
          {@const stars = review.stars ? parseInt(review.stars) : 5}
          <div class="rounded-sm bg-highlight p-3 max-w-[--main-max-width]">
            <div class="flex items-center justify-between">
              <div>
                {#each Array(stars) as _}
                  <Icon size="xs" icon="star-filled" class="text-accent" />
                {/each}
              </div>
              <p class="text-sm text-primary/80">{review.name}</p>
            </div>
            <div class="mt-4">
              <p class="text-md font-semibold">{review.title}</p>
              <p class="mt-1 text-md">{review.text}</p>
            </div>
          </div>
        {:else if review.component === 'review-photo' && review.photo}
          <CmsImage
            image={review.photo}
            alt={review.photo.alt}
            class="max-w-[--main-max-width] aspect-[83/70] w-full md:max-h-[300px] lg:max-h-[280px] object-cover rounded-sm"
          />
        {/if}
      {/each}
    </div>
  </div>
{/if}

<style lang="postcss">
  .reviews-item {
    @media screen and (min-width: 640px) {
      --main-max-height: calc(300px * 6);
      --main-max-width: calc((100% / 2) - 16px);
    }
    @media screen and (min-width: 1024px) {
      --main-max-height: calc(280px * 3);
      --main-max-width: calc((100% / 4) - 16px);
    }
  }
</style>
